import { BaseRule } from './edit/rules/type'

enum SpreadsheetType {
    string = 'string',
    number = 'number',
    date = 'date'
}

interface SpreadsheetHeader {
    name: string
    alias: string
    type: SpreadsheetType
    isKey: boolean
    isNotNull: boolean
    isDisabled: boolean
    validators: any[]
    format?: string
}

interface TemplateHeaderPreview {
    uid: string
    sheetData: TemplateHeaderPreviewData[]
    fileName:string
}

interface TemplateHeaderPreviewData {
    sheetName: string
    header: SpreadsheetHeader[]
    rows: TemplateHeaderPreviewDataCell[][]
}

interface TemplateHeaderPreviewDataCell {
    value: string
    parsed: string
}

interface EventBatch {
    [key: string]: string
}

interface Database {
    perspective: number
    keys: string[]
    headers: SpreadsheetHeader[]
    eventType: string
    databaseName?: string
    dateReference?: boolean
    skipRealtime: boolean
    rules?: BaseRule[]
}
export { TemplateHeaderPreview, SpreadsheetHeader, SpreadsheetType, EventBatch, Database }
